export default {
  obects: {
    results: [],
  },

  warehouse: [],

  warehouse_scroll: {
    count: 0,
    next: 0,
    results: [],
  },
  warehouseTable: {
    results: [],
  },
  warehouseId: {
    results: [],
    user: [],
  },
  warehouseModale: {
    results: [],
    user: [],
  },
  warehousePinModal: {
    results: [],
  },
};
